export type JBTdropdownProps = {
  isOpen: boolean;
  onClose: () => void;
  HtmlSource: any;
  styleKey: string;
  updateUser: () => void;
};

export enum numberType {
  JBT = "JBT",
  PHONE = "Phone",
}
